/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendSummaryListRequest extends models.InfraResourceTrendRequestBase {
    getFixupPrototypeFunction() { return InfraResourceTrendSummaryListRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendSummaryListRequest>): InfraResourceTrendSummaryListRequest {
        let obj = Object.assign(new InfraResourceTrendSummaryListRequest(), model);
        InfraResourceTrendSummaryListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendSummaryListRequest>): InfraResourceTrendSummaryListRequest {
        if (!model) return null;
        return InfraResourceTrendSummaryListRequest.newInstance(<InfraResourceTrendSummaryListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendSummaryListRequest) {
        if (!obj) return;

        models.InfraResourceTrendSummaryListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendSummaryListRequest): boolean {
        if (models.InfraResourceTrendRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraResourceTrendSummaryListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.InfraResourceTrendListBaseFilters.fixupPrototype(this.filters);
        }
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
    }

    /**
     * Filters applied to the trend data.
     */
    filters: models.InfraResourceTrendListBaseFilters;

    /**
     * Optional list context
     */
    list_context: models.ListContext;

}
